import React, { useCallback } from 'react'
import { Image } from '@/atoms/Image'
import { CaptionMD, HeadingMD } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useSafeAnalytics } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchSubmitButton } from '../TorchSubmitButton'

export const SubmissionFlowSection: React.FC = () => {
  const { track } = useSafeAnalytics()
  const { t } = useTranslate('create')

  const handleGetStartedClicked = useCallback(() => {
    track('Guild Submit Project Clicked')
  }, [track])

  return (
    <section
      className="w-full bg-core-gray-100 py-16 md:py-24"
      style={{
        backgroundImage: 'linear-gradient(180deg, #F5F5F4 0%, #C3C1C0 100%)',
      }}
    >
      <div className="mx-auto max-w-[1440px] px-4 md:px-12 lg:px-[120px]">
        <HeadingMD
          weight="bold"
          color="core-gray-950"
          className="md:photon-heading-xl lg:photon-display mb-12 text-center"
        >
          {t('howSubmissionWorks', 'How Your Submission Works')}
        </HeadingMD>

        <div className="mb-12 flex justify-center">
          {/* Horizontal flow for larger screens */}
          <Image
            alt={t('submissionFlowDiagram', 'Submission Flow Diagram')}
            className="hidden w-full max-w-[1200px] md:block"
            src={getCloudinaryImageUrl({
              path: '/v1753128874/angel-app/guild/submit-screen/submission-flow-horizontal.png',
            })}
            width={1200}
            height={400}
          />
          {/* Vertical flow for smaller screens */}
          <Image
            alt={t('submissionFlowDiagram', 'Submission Flow Diagram')}
            className="block w-full max-w-[600px] md:hidden"
            src={getCloudinaryImageUrl({
              path: '/v1753128874/angel-app/guild/submit-screen/submission-flow-vertical.png',
            })}
            width={600}
            height={800}
          />
        </div>

        <div className="flex flex-col items-center gap-4">
          <TorchSubmitButton handleSubmitClicked={handleGetStartedClicked} isDark={false} />
          <CaptionMD weight="normal">{t('applicationFee', '$250 application fee')}</CaptionMD>
        </div>
      </div>
    </section>
  )
}
